var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 139,
    viewBox: "0 0 138 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2991 28.7326C92.9317 23.1331 89.5409 18.1028 85.2299 13.7763C80.919 9.46023 75.8844 6.06531 70.2916 3.69508C64.5023 1.24204 58.3409 0 52.0037 0C43.6093 0 35.3699 2.24603 28.1747 6.48968C21.2689 10.5677 15.49 16.3639 11.4375 23.2883L12.1301 23.692C20.4005 9.56374 35.649 0.807329 52.0037 0.807329C77.4765 0.807329 98.1937 21.5495 98.1937 47.0528C98.1937 72.4629 77.6212 93.1533 52.2725 93.2982V94.1055C58.527 94.0745 64.585 92.8324 70.3019 90.4104C75.8947 88.0402 80.919 84.6453 85.2403 80.3292C89.5512 76.0131 92.9421 70.9725 95.3095 65.3729C97.7596 59.5767 99.0001 53.4079 99.0001 47.0631C99.0001 40.7183 97.7492 34.5392 95.2991 28.7326Z",
    fill: "#6F5C91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81749 47.0425C7.81749 40.3252 9.33718 33.7009 12.2525 27.7081C12.8004 26.5799 12.3972 25.224 11.3117 24.603L11.26 24.5719C10.0608 23.8784 8.53081 24.3442 7.92087 25.5966C6.58728 28.3394 5.51213 31.1961 4.7161 34.1253C3.57893 38.3172 3 42.6643 3 47.0425C3 53.6668 4.29225 60.0944 6.85606 66.139C9.32684 71.9766 12.8521 77.2242 17.3594 81.737C21.8565 86.2394 27.0978 89.7792 32.9388 92.253C37.9113 94.3541 43.1423 95.6065 48.5181 95.9894C49.9034 96.0826 51.0716 94.9958 51.0716 93.6088V93.5571C51.0716 92.2944 50.0998 91.2697 48.8386 91.1765C25.94 89.5308 7.81749 70.3619 7.81749 47.0425Z",
    fill: "#6F5C91"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_733_2182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0023 87.2454C74.178 87.2454 92.155 69.2469 92.155 47.0446C92.155 24.8423 74.178 6.84375 52.0023 6.84375C29.8266 6.84375 11.8496 24.8423 11.8496 47.0446C11.8496 69.2469 29.8266 87.2454 52.0023 87.2454Z",
    fill: "url(#paint0_linear_733_2182)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3886 86.4055C73.8392 86.4055 91.2283 68.9955 91.2283 47.5191C91.2283 26.0428 73.8392 8.63281 52.3886 8.63281C30.938 8.63281 13.5488 26.0428 13.5488 47.5191C13.5488 68.9955 30.938 86.4055 52.3886 86.4055Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2187 47.2344V28.8136H32.7299V47.2344H29.2187ZM25.6027 31.9056V28.8136H32.4679V31.9056H25.6027ZM43.3208 47.4964C41.8709 47.4964 40.5608 47.1034 39.3904 46.3173C38.22 45.5312 37.2854 44.4219 36.5867 42.9895C35.9054 41.557 35.5647 39.8888 35.5647 37.9847C35.5647 36.0806 35.9054 34.4211 36.5867 33.0061C37.2679 31.5912 38.185 30.4906 39.338 29.7045C40.5084 28.9184 41.8098 28.5254 43.2422 28.5254C44.7096 28.5254 46.0198 28.9184 47.1727 29.7045C48.3431 30.4906 49.2689 31.5999 49.9502 33.0323C50.6315 34.4473 50.9721 36.1155 50.9721 38.0371C50.9721 39.9412 50.6315 41.6095 49.9502 43.0419C49.2689 44.4569 48.3518 45.5574 47.1989 46.3435C46.046 47.1121 44.7533 47.4964 43.3208 47.4964ZM43.2684 44.2734C44.1069 44.2734 44.8319 44.0376 45.4433 43.5659C46.0547 43.0943 46.5264 42.3955 46.8583 41.4697C47.2076 40.5439 47.3823 39.3909 47.3823 38.0109C47.3823 36.6309 47.2076 35.4779 46.8583 34.5521C46.5264 33.6263 46.046 32.9362 45.4171 32.4821C44.8057 32.0104 44.0807 31.7746 43.2422 31.7746C42.4212 31.7746 41.705 32.0104 41.0936 32.4821C40.4822 32.9362 40.0018 33.6263 39.6524 34.5521C39.3205 35.4605 39.1546 36.6047 39.1546 37.9847C39.1546 39.3822 39.3205 40.5439 39.6524 41.4697C40.0018 42.3955 40.4822 43.0943 41.0936 43.5659C41.705 44.0376 42.4299 44.2734 43.2684 44.2734Z",
    fill: "#6F5C91"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2032 63.8534L61.3197 58.5052C61.6801 58.1191 61.9697 57.778 62.1885 57.4819C62.4202 57.173 62.5875 56.8834 62.6905 56.6131C62.7935 56.3299 62.845 56.0467 62.845 55.7635C62.845 55.1972 62.6583 54.7531 62.285 54.4313C61.9246 54.1095 61.4548 53.9486 60.8756 53.9486C60.2835 53.9486 59.7557 54.1031 59.2924 54.412C58.8419 54.7209 58.4171 55.2101 58.0181 55.8794L56.2225 54.3541C56.7631 53.4402 57.4324 52.7516 58.2305 52.2882C59.0414 51.8119 59.9681 51.5738 61.0107 51.5738C61.8989 51.5738 62.6712 51.7476 63.3276 52.0951C63.997 52.4426 64.5118 52.9253 64.8722 53.5432C65.2326 54.161 65.4129 54.8818 65.4129 55.7056C65.4129 56.2591 65.3421 56.7611 65.2005 57.2116C65.0718 57.6621 64.8465 58.1126 64.5247 58.5631C64.2158 59.0008 63.7846 59.4963 63.2311 60.0498L59.5048 63.8534H56.2032ZM56.2032 65.3594V63.8534L58.4428 63.0811H65.7025V65.3594H56.2032ZM66.8558 60.5711L71.4896 51.7862H74.3857L69.6361 60.5711H66.8558ZM66.8558 62.1157V60.5711L67.8212 59.8181H77.5521V62.1157H66.8558ZM73.2659 65.3594V56.7096H75.8531V65.3594H73.2659Z",
    fill: "#6F5C91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5801 33.1094L43.9668 65.8687",
    stroke: "#6F5C91",
    strokeWidth: 1.48906,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_733_2182",
    x: 0.555637,
    y: 1.19676,
    width: 136.775,
    height: 136.868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 16.941,
    dy: 22.5879
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.1175
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839653 0 0 0 0 0.839653 0 0 0 0 0.891667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_733_2182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_733_2182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_2182",
    x1: 76.9955,
    y1: 78.5026,
    x2: 26.9321,
    y2: 15.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.4e-7,
    stopColor: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.c8356ec0c23952c0f5fe7da1fa312534.svg";
export { ForwardRef as ReactComponent };